import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { RegisterParameterEntryResponseData } from "@opus-dt/shared-types";
import { api } from "@/lib/api-client";

// Reporte de produção por máquina. Reusa o endpoint de entry de
// parâmetro, mas o rollup recalcula ProductionRun.producedQty na mesma transação,
// alimentando OEE/aderência/eventos. Por isso a invalidação é COMPLETA (molde de
// useRegisterStatusEntry): parameters + machine + machines + lines + events + oee +
// production active. Realtime (PRODUCTION_UPDATED/OEE_UPDATED) cobre os demais viewers.
export function useRegisterProductionEntry(machineId: string, lineId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ parameterId, value }: { parameterId: string; value: string }) =>
      api.post<RegisterParameterEntryResponseData>(
        `/api/v1/machines/${machineId}/parameters/${parameterId}/entries`,
        { value }
      ),
    meta: { skipErrorToast: true },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["parameters", machineId] });
      void qc.invalidateQueries({ queryKey: ["machine", machineId] });
      void qc.invalidateQueries({ queryKey: ["machines", lineId] });
      void qc.invalidateQueries({ queryKey: ["lines", lineId] });
      void qc.invalidateQueries({ queryKey: ["events", lineId] });
      void qc.invalidateQueries({ queryKey: ["oee", lineId] });
      void qc.invalidateQueries({ queryKey: ["production", "active", lineId] });
    },
  });
}
